/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_7_Object_DescInputs */

const en_privacy_section_7_object_desc = /** @type {(inputs: Privacy_Section_7_Object_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`object to the processing of your personal data for certain purposes`)
};

const lv_privacy_section_7_object_desc = /** @type {(inputs: Privacy_Section_7_Object_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`iebilst pret Jūsu personas datu apstrādi noteiktiem nolūkiem`)
};

/**
* | output |
* | --- |
* | "object to the processing of your personal data for certain purposes" |
*
* @param {Privacy_Section_7_Object_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_7_object_desc = /** @type {((inputs?: Privacy_Section_7_Object_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_7_Object_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_7_object_desc(inputs)
	return en_privacy_section_7_object_desc(inputs)
});